// src/index.ts
import { createClient } from "@supabase/supabase-js";
import { createHmac } from "crypto";

// src/types.gen.ts
var Constants = {
  public: {
    Enums: {
      app_language: ["en", "fr"],
      dashboard_email_cadence: ["daily", "weekly", "monthly"],
      measurement_unit: ["m3", "l"],
      meter_reading_method: ["cumulative", "incremental"],
      ops_compatibility_status: [
        "pending",
        "in_analysis",
        "not_compatible",
        "compatible_supported",
        "compatible_approved",
        "compatible_not_supported"
      ]
    }
  }
};

// src/index.ts
var base64url = (input) => Buffer.from(input).toString("base64url");
var signHS256JWT = (payload, secret) => {
  const header = { alg: "HS256", typ: "JWT" };
  const signingInput = `${base64url(JSON.stringify(header))}.${base64url(JSON.stringify(payload))}`;
  const signature = createHmac("sha256", secret).update(signingInput).digest("base64url");
  return `${signingInput}.${signature}`;
};
var makeSupabaseClient = ({
  supabaseUrl = process.env.SUPABASE_URL ?? "",
  projectId = process.env.SUPABASE_PROJECT_ID ?? "",
  key = process.env.SUPABASE_ANON_KEY ?? "",
  options
}) => {
  const url = supabaseUrl || `https://${projectId}.supabase.co`;
  return createClient(url, key, options);
};
var makeSupabaseClientFromUserToken = (token) => makeSupabaseClient({
  options: {
    global: {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  }
});
var makeSuperAdminSupabaseClient = () => makeSupabaseClient({ key: process.env.SUPABASE_SERVICE_ROLE_KEY ?? "" });
var ORG_SCOPED_SERVICE_ACCOUNT_SUB = "service_account";
var makeOrgScopedServiceAccountToken = (orgID) => {
  const nowInSec = Math.floor(Date.now() / 1e3);
  const jwtPayload = {
    role: "authenticated",
    email: "serviceaccount@meetwillie.com",
    exp: nowInSec + 3600,
    sub: ORG_SCOPED_SERVICE_ACCOUNT_SUB,
    iat: nowInSec,
    org_id: orgID
  };
  const token = signHS256JWT(jwtPayload, process.env.SUPABASE_JWT_SECRET ?? "");
  return {
    token,
    jwtPayload
  };
};
var makeOrgScopedServiceAccountSupabaseClient = (orgID) => {
  const { token } = makeOrgScopedServiceAccountToken(orgID);
  return makeSupabaseClient({
    options: {
      global: {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    }
  });
};
export {
  Constants,
  ORG_SCOPED_SERVICE_ACCOUNT_SUB,
  makeOrgScopedServiceAccountSupabaseClient,
  makeOrgScopedServiceAccountToken,
  makeSupabaseClient,
  makeSupabaseClientFromUserToken,
  makeSuperAdminSupabaseClient
};
//# sourceMappingURL=index.js.map